import { useSubscribe, useUnSubscribe } from "@/hooks/common/useObserver";
import { __EVENT_FEILD_CHANGE__ } from "@/const/event";

// 监听当前字段变化
export const useFormFieldChange = (cb = () => {}) => {
    return useSubscribe(__EVENT_FEILD_CHANGE__, cb);
};

export const useUnSubscribeFormFieldChange = (token) => {
    return useUnSubscribe(__EVENT_FEILD_CHANGE__, token);
};